import React from "react";
import { Phone, Mail, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND, GITES } from "@/data";
import { EN } from "@/en";

export default function ContactEn() {
  const t = EN.contact;
  return (
    <div data-testid="page-contact-en" className="py-20 lg:py-28">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <span className="text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">{t.overline}</span>
        <h1 className="font-serif text-5xl lg:text-6xl font-light mt-5 text-forest">{t.title}</h1>
        <p className="text-charcoal/70 mt-6 text-lg">{t.intro}</p>

        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          <a href={BRAND.emailLink} data-testid="contact-email-en">
            <Button className="w-full rounded-full bg-forest hover:bg-forest-dark text-cream h-12"><Mail className="mr-2 w-4 h-4" /> {t.email}</Button>
          </a>
          <a href={BRAND.phoneLink} data-testid="contact-phone-en">
            <Button variant="outline" className="w-full rounded-full border-forest/30 text-forest hover:bg-forest hover:text-cream h-12"><Phone className="mr-2 w-4 h-4" /> {t.call}</Button>
          </a>
        </div>

        <div className="mt-10">
          <h2 className="font-serif text-2xl text-forest mb-4">{t.bookingTitle}</h2>
          <div className="grid sm:grid-cols-2 gap-4">
            {GITES.map((g) => (
              <a key={g.id} href={g.booking} target="_blank" rel="noopener noreferrer" data-testid={`contact-booking-${g.id}-en`}>
                <Button variant="outline" className="w-full rounded-full border-brown/30 text-brown hover:bg-brown hover:text-cream h-12">
                  {t.bookingOn(g.name)} <ExternalLink className="ml-2 w-4 h-4" />
                </Button>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-sand text-charcoal/70 space-y-2">
          <p className="flex items-center gap-3"><Phone className="w-5 h-5 text-forest" strokeWidth={1.5} /> {BRAND.phone}</p>
          <p className="flex items-center gap-3"><Mail className="w-5 h-5 text-forest" strokeWidth={1.5} /> {BRAND.email}</p>
        </div>
      </div>
    </div>
  );
}
